import React, { useState } from 'react'
import styles from './style'
import propTypes from './prop'
import { Grid, withStyles, Box, Alert } from '@material-ui/core'
import translator from 'src/translate'
import { cardPatchAction } from 'src/reducers/card/action'
import { QuestionFieldNames } from 'src/model/card'
import { PatchContent, PatchData } from 'src/model/patch'
import { CoreTextField } from 'src/components/core'
import { useSelector } from 'react-redux'

const QuestionNumericEntry = props => {
  const { classes, dispatch } = props
  const entity = useSelector(state => state.card.currentCard)
  const [maxValue, setMaxValue] = useState(entity[QuestionFieldNames.MAX_VALUE])

  /**
   *
   * @param {*} e
   */
  const changeHandle = e => {
    setMaxValue(e.target.value)

    dispatch(
      cardPatchAction(
        new PatchData(
          new PatchContent(
            e.target.value,
            QuestionFieldNames.MAX_VALUE,
            PatchContent.OPERATION_REPLACE,
          ),
          entity[QuestionFieldNames.ID],
        ),
        () => {},
      ),
    )
  }

  return (
    <Grid container justifyContent="center" alignContent="center">
      <Grid item className={classes.grid}>
        <Alert severity="info">
          Set the highest number learners can provide.
        </Alert>
        <CoreTextField
          type="number"
          label={translator._('question.addQuestion.answerType.maxValue')}
          value={maxValue}
          fullWidth
          onChange={changeHandle}
        />
      </Grid>
    </Grid>
  )
}

QuestionNumericEntry.propTypes = propTypes

export default withStyles(styles)(QuestionNumericEntry)
